import { useState, useEffect } from 'react';

type useMediaQueryReturn<T> = T extends number ? [boolean, number] : [number];

// Custom hook that returns if current screen width is larger than
// the width breakpoint argument or not
const useMediaQuery = <T>(breakpoint?: T) => {
  const [width, setWidth] = useState(0);
  const [isClient, setIsClient] = useState(false);

  const updateWidth = () => setWidth(window.innerWidth);

  useEffect(() => {
    setIsClient(true);
    updateWidth();
    window.addEventListener('resize', updateWidth);

    return () => window.removeEventListener('resize', updateWidth);
  }, []);

  // During SSR and initial render, assume mobile-first (false for breakpoint checks)
  const actualWidth = isClient ? width : 0;
  const meetsBreakpoint = isClient && breakpoint ? actualWidth >= +breakpoint : false;

  return (breakpoint ? [meetsBreakpoint, actualWidth] : [actualWidth]) as useMediaQueryReturn<T>;
};

export default useMediaQuery;
